import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "./router";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
//import { Theme } from "@radix-ui/themes";
import { logger } from "@/client/services/logger/logger";
import { ErrorBoundary } from "@/client/pages/public/error-boundary";
import { registerServiceWorker } from "./libs/register-sw";
import { capturePromoLink } from "./services/promo-link/storage";

window.addEventListener("error", (e) => {
  logger.error("Uncaught JS error", e.error, "window");
});
window.addEventListener("unhandledrejection", (e) => {
  logger.error("Unhandled promise rejection", e.reason, "window");
});
registerServiceWorker();
capturePromoLink(window.location.search);

const root = ReactDOM.createRoot(document.querySelector("#root")!);

root.render(
  // <Theme>

  <StrictMode>
    <ChakraProvider value={defaultSystem}>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </ChakraProvider>
  </StrictMode>,
);
